import { render } from "./MarketingAreas.vue?vue&type=template&id=07e30bc3&scoped=true"
import script from "./MarketingAreas.vue?vue&type=script&lang=js"
export * from "./MarketingAreas.vue?vue&type=script&lang=js"

import "./MarketingAreas.vue?vue&type=style&index=0&id=07e30bc3&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e30bc3"]])

export default __exports__